import { Goerli } from "@usedapp/core";

export const ROUTER_ADDRESS = "0x7eB4F3b8ACB4680E88a40334E442Ea1bCa300665"; 

export const DAPP_CONFIG = {
  readOnlyChainId: Goerli.chainId,
  readOnlyUrls: {
    [Goerli.chainId]: "https://eth-goerli.g.alchemy.com/v2/o_mWqJ_DvZsCu7VWp4i_C3bvqZ-KDQhz",
  },
};